import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";


import "../src/products.scss";

Rails.start();
Turbolinks.start();
